import { useContext } from 'react'
import { useQuery, QueryKey } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import ApiContext from '../../context/ApiContext'
import { toast } from 'sonner'

export const getCompanyManagerQueryKey = (companyId?: string): QueryKey => ['company-manager', companyId]

interface UseCompanyManagerResult {
	isManager: boolean
	isLoading: boolean
	error: Error | null
}

const useCompanyManager = (companyId?: string): UseCompanyManagerResult => {
	const apiContext = useContext(ApiContext)

	const { data, isLoading, error } = useQuery({
		queryKey: getCompanyManagerQueryKey(companyId),
		queryFn: async (): Promise<{ isManager: boolean }> => {
			try {
				const auth = getAuth()
				const idToken = await auth.currentUser?.getIdToken(true)
				const response = await fetch(`${apiContext.apiUrl}/companies/${companyId}/is-manager`, {
					headers: {
						Authorization: `Bearer ${idToken}`,
					},
				})

				if (!response.ok) {
					throw new Error(await response.text())
				}

				return response.json()
			} catch (error) {
				toast.error('Something went wrong, with checking permissions')
				return { isManager: false }
			}
		},
		enabled: !!companyId,
	})

	return { isManager: data?.isManager ?? false, isLoading, error }
}

export default useCompanyManager
